import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import { Alert, message as AntMessage, Typography } from "antd"
// const { Paragraph, Text } = Typography;
import { useTranslation } from "react-i18next"
import classnames from "classnames"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
// Redux

import { connect, useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

// actions
// import { loginUser, apiError } from "../../store/actions"
import { loginAgent, loginClub } from "store/auth/login/loginSlice"

// import images

import logo from "../../assets/images/logo.png"
import LoginForm from "./components/LoginForm"
import PaymentInfoPopup from "./components/PaymentInfoPopup"
import { toast } from "react-toastify"

const Login = (props) => {
  const [searchParams] = useSearchParams();
  const role = searchParams.get("role") || "club";
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [userLogin, setUserLogin] = useState([])
  const [activeTab, setActiveTab] = useState(role === "agent" ? "2" : "1");
  const { agent, club, user, error, loading } = useSelector((state) => state.Login)
  const [responseData, setResponseData] = useState(null);
  const [emailData, setEmailData] = useState(null);
  const [showPaymentPopup, setShowPaymentPopup] = useState(null);
  const togglePaymentPopup = () => setShowPaymentPopup((v) => !v);
  const navigate = useNavigate()

  useEffect(() => {
    setActiveTab(role === "agent" ? "2" : "1");
  }, [role]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab)

      validation.setFieldValue("email", "")
      validation.setFieldValue("password", "")
    }
  }
  useEffect(() => {
    setResponseData(error);
  }, [error])

  const location = useLocation();
  useEffect(() => {
    if (location.state?.email) {
      setTimeout(() => {
        setShowPaymentPopup(true);
        setEmailData(location.state?.email);
      }, 1500);
    }
  }, [location.state]);

  useEffect(() => {
    if (responseData?.status === "Blocked") {
      // AntMessage.info("Votre paiement a été refusé pour la raison suivante : " + responseData?.paymentRejectionReason)
      toast.info("Votre paiement a été refusé pour la raison suivante : " + responseData?.paymentRejectionReason, {
        position: "top-center",
      });
    } else {
      if (responseData) {
        setEmailData(responseData?.email);
        // if (responseData && responseData.imageChecked != null) {
        //   if (!responseData?.imageChecked) {
        //     setShowPaymentPopup(true)
        //   } else {
        //     // AntMessage.info(responseData.message)
        //     toast.error(responseData.message, {
        //       position: "top-center",
        //     });
        //   }

        // } else {
        //   setShowPaymentPopup(false)
        //   // AntMessage.info(responseData?.message)
        //   toast.error(responseData?.message, {
        //     position: "top-center",
        //   });

        // }

        if (responseData.hasPaidWithPaypal || responseData.imageChecked != null) {
          if (responseData.hasPaidWithPaypal) {
            setShowPaymentPopup(false);
            // AntMessage.success(responseData.message);
            toast.error(responseData.message, {
              position: "top-center",
            });
          } else if (responseData.imageChecked != null) {
            if (!responseData.imageChecked) {
              setShowPaymentPopup(true);
            } else {
              // AntMessage.info(responseData.message);
              toast.error(responseData.message, {
                position: "top-center",
              });
            }
          } else {
            setShowPaymentPopup(false);
            // AntMessage.info(responseData?.message);
            toast.error(responseData?.message, {
              position: "top-center",
            });
          }
        } else {
          setShowPaymentPopup(false);
          // AntMessage.info(responseData?.message);
          toast.error(responseData?.message, {
            position: "top-center",
          });
        }
      }
    }

  }, [responseData])
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values need to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required(t("login.usernameRequired")),
      password: Yup.string().required(t("login.passwordRequired")),
    }),
    onSubmit: (values) => {
      if (activeTab === "1") {
        dispatch(loginClub({ user: values, history: navigate }))
      } else {
        dispatch(loginAgent({ user: values, history: navigate }))
      }
    },
  })
  document.title = "Login | Playmaker Club"

  return (
    <React.Fragment>
      <div className="d-flex justify-content-end">
        <div style={{ marginRight: "4%" }}>
          <LanguageDropdown />
        </div>

        <div className="home-btn d-none d-sm-block">
          <Link to="https://playmaker-club.com" className="text-dark">
            <i className="fas fa-home h2" />
          </Link>
        </div>
      </div>

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <PaymentInfoPopup
            open={showPaymentPopup}
            onClose={togglePaymentPopup}
            phoneNumber="+213 554 17 05 32"
            emailContact="team.playmaker.club@gmail.com"
            email={emailData}
          />
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={4}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20">
                      {t("login.welcomeBack")}{" "}
                      {/* Traduction de "Welcome Back" */}
                    </h5>
                    <p className="text-white-50">
                      {t("login.signInMessage")} {/* Traduction du message */}
                    </p>
                    <Link to="/" className="logo logo-admin">
                      <img src={logo} height="55" alt="logo" />
                    </Link>
                  </div>
                </div>

                <CardBody className="p-4">
                  <div className="p-3">
                    <Nav tabs className="mb-4">
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "1" })}
                          onClick={() => toggleTab("1")}
                          role="button"
                        >
                          Club
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "2" })}
                          onClick={() => toggleTab("2")}
                          role="button"
                        >
                          Agent
                        </NavLink>
                      </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1">
                        <LoginForm
                          validation={validation}
                          loading={loading}
                          activeTab={activeTab}
                        />
                      </TabPane>
                      <TabPane tabId="2">
                        <LoginForm
                          validation={validation}
                          loading={loading}
                          activeTab={activeTab}
                        />
                      </TabPane>
                    </TabContent>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("login.noAccount")}{" "}
                  {/* Traduction de "Don't have an account ?" */}
                  <Link to="/register" className="fw-medium text-primary">
                    {t("login.signupNow")} {/* Traduction de "Signup now" */}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Login
